module.exports = __webpack_public_path__ + "img/senderrand-logistics-banner-image.7c1400b9.svg";